<app-go-further-links [links]="links" />
